import { useEffect } from "react";
import { CircularProgress, Box, Typography } from "@mui/material";
import { usePaymentApiCall } from "../hooks/usePaymentApiCall";
import { usePaymentIframe } from "../hooks/usePaymentIframe";
import "./PaymentApiIframePage.css";
import { useFormContext } from "../../../common/contexts/FormContext";
import { sessionStorageUtils } from "../../../utility/utility";
import { SESSION_FORMVALUES } from "../../../constants/constant";
import PaymentErrorModal from "./PaymentErrorModal";
import { Step } from "../../../Interface/scheduler/form";
import { useFormConfigContext } from "../../../common/contexts/FormConfigContext";
import isInboundFromNbly from "../../../utility/checkInBoundFromNbly";

interface PaymentIframePageProps {
  config: Step;
}

const PaymentApiFramePage = ({ config }: PaymentIframePageProps) => {
  const { loading, error, response, makePaymentRequest } = usePaymentApiCall();
  const { formValues } = useFormContext();
  const { formConfig } = useFormConfigContext();
  const { iframeRef, iframeLoading, handleIframeLoad, handleIframeError } =
    usePaymentIframe();

  useEffect(() => {
    makePaymentRequest({
      conceptId: formConfig?.conceptid || "",
      vendorId: formConfig?.conceptCode || "",
      CustomerNumber: formValues?.customerNumber,
    });
  }, [makePaymentRequest]);

  useEffect(() => {
    sessionStorageUtils.setItem(SESSION_FORMVALUES, JSON.stringify(formValues));
  }, [formValues]);

  useEffect(() => {
    if (error === "IFrame Closed") {
      if (isInboundFromNbly()) {
        globalThis.location.replace(
          `${formConfig?.redirectionPageUrl}?leadconcept=${formConfig.conceptCode}`,
        );
        return;
      }
      globalThis.location.replace(
        formConfig?.redirectionPageUrl || "/confirmation",
      );
    }
  }, [error, formConfig]);
  // Loading state
  if (loading) {
    return (
      <div className="payment-api-iframe-container">
        <Box display="flex" flexDirection="column" alignItems="center" p={4}>
          <CircularProgress size={60} />
        </Box>
      </div>
    );
  }

  // Success state with iframe
  if (response?.success && response.iframeUrl) {
    return (
      <>
        <div className="payment-api-iframe-container">
          <div className="payment-iframe-wrapper">
            {iframeLoading && (
              <div className="iframe-loader-overlay">
                <CircularProgress />
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Loading payment form...
                </Typography>
              </div>
            )}
            <iframe
              id="payment-iframe"
              ref={iframeRef}
              className={`payment-api-iframe ${iframeLoading ? "loading" : "loaded"}`}
              title="Payment Form"
              src={response.iframeUrl}
              onLoad={handleIframeLoad}
              onError={handleIframeError}
              sandbox="allow-forms allow-scripts allow-same-origin allow-top-navigation allow-popups allow-popups-to-escape-sandbox"
              data-testid="payment-iframe"
              allow="payment"
            />
          </div>
        </div>
        {error === "Payment failed" && (
          <PaymentErrorModal
            paymentFailureMessage={config?.paymentFailureMessage}
            paymentBtnLabel={config?.paymentBtnLabel}
          />
        )}
      </>
    );
  }

  return null;
};

export default PaymentApiFramePage;
